import { render, staticRenderFns } from "./LinkCertificationTrainingManagement.vue?vue&type=template&id=61d3f01a&scoped=true"
import script from "./LinkCertificationTrainingManagement.vue?vue&type=script&lang=js"
export * from "./LinkCertificationTrainingManagement.vue?vue&type=script&lang=js"
import style0 from "./LinkCertificationTrainingManagement.vue?vue&type=style&index=0&id=61d3f01a&prod&lang=scss"
import style1 from "./LinkCertificationTrainingManagement.vue?vue&type=style&index=1&id=61d3f01a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61d3f01a",
  null
  
)

export default component.exports